import { ILogMessageParams } from '@shared/logger/i_log_message_params';
import { timestamp_ms } from './utils_time';
import { DTOPerformaceCapture } from './performance/dto_performance_capture';
import { EPerformaceReferenceDuration } from './performance/e_performance_reference';

export function create_performace_capture(label: string, performance_reference: number = EPerformaceReferenceDuration.DEFAULT) {
  let out: DTOPerformaceCapture = new DTOPerformaceCapture();

  out.id = crypto.randomUUID();
  out.label = label;
  out.timestamp_start = timestamp_ms();
  out.performance_reference = performance_reference;

  return out;
}

export function try_measure_performance_capture(params: ILogMessageParams) {
  let { performance_capture } = params;

  if (!performance_capture) return;

  performance_capture.measure();
}
